/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Context_Cancel_EmbedInputs */



/**
* | output |
* | --- |
* | "Cancel Embedding" |
*
* @param {Spaces_Context_Cancel_EmbedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_context_cancel_embed = /** @type {((inputs?: Spaces_Context_Cancel_EmbedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Context_Cancel_EmbedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettung abbrechen")
	return /** @type {LocalizedString} */ ("Cancel Embedding")
});